import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from "src/environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../core/authentication/authentication.service";
const MINUTES_UNITL_AUTO_LOGOUT = 30; // in mins
const CHECK_INTERVAL = 30000; // in ms
const STORE_KEY = 'lastAction';
export class AutoLogoutService {
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
        this.helper = new JwtHelperService();
        this.check();
        this.initListener();
        this.initInterval();
        localStorage.setItem(STORE_KEY, Date.now().toString());
    }
    getLastAction() {
        return parseInt(localStorage.getItem(STORE_KEY));
    }
    setLastAction(lastAction) {
        localStorage.setItem(STORE_KEY, lastAction.toString());
    }
    initListener() {
        document.body.addEventListener('click', () => this.reset());
        document.body.addEventListener('mouseover', () => this.reset());
        document.body.addEventListener('mouseout', () => this.reset());
        document.body.addEventListener('keydown', () => this.reset());
        document.body.addEventListener('keyup', () => this.reset());
        document.body.addEventListener('keypress', () => this.reset());
    }
    reset() {
        this.setLastAction(Date.now());
    }
    initInterval() {
        setInterval(() => {
            this.check();
        }, CHECK_INTERVAL);
    }
    check() {
        const now = Date.now();
        const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
        const diff = timeleft - now;
        var isTimeout = diff < 0;
        console.log("isTimeout= " + isTimeout);
        if (isTimeout) {
            //  localStorage.clear();
            console.log("isTimeout11= " + isTimeout);
            isTimeout = false;
            sessionStorage.removeItem('historyNavigation');
            this.authenticationService.logout();
            localStorage.clear();
            window.location.href = environment.domainLoginPortal;
            // this.router.navigate([environment.domainLoginPortal]);
        }
    }
}
AutoLogoutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AutoLogoutService_Factory() { return new AutoLogoutService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthenticationService)); }, token: AutoLogoutService, providedIn: "root" });
